const VIDEO_KEY_PREFIX = "demoAttrVideo";
const CONSUME_KEY_PREFIX = "demoAttrConsume";
const ARMED_VALUE = "armed";

const buildKey = (prefix: string, userId: string): string =>
  `${prefix}:${userId}`;

/**
 * デモ通話経由の課金アトリビューションを付与する（userId 単位、恒久フラグ）。
 * 応答直後に呼び、以降 video/consume それぞれ最初の1回だけ消費される。
 */
export const armDemoCallAttribution = (userId: string): void => {
  if (!userId) return;
  try {
    localStorage.setItem(buildKey(VIDEO_KEY_PREFIX, userId), ARMED_VALUE);
    localStorage.setItem(buildKey(CONSUME_KEY_PREFIX, userId), ARMED_VALUE);
  } catch {
    // localStorage 不可: アトリビューションは付与されないが致命的ではないため無視
  }
};

/**
 * video 用アトリビューションが armed なら消費して true を返す（一度きり）。
 */
export const takeVideoCallAttribution = (userId: string): boolean => {
  if (!userId) return false;
  try {
    const key = buildKey(VIDEO_KEY_PREFIX, userId);
    if (localStorage.getItem(key) !== ARMED_VALUE) return false;
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

/**
 * consume 用アトリビューションが armed なら消費して true を返す（一度きり）。
 */
export const takePointConsumeAttribution = (userId: string): boolean => {
  if (!userId) return false;
  try {
    const key = buildKey(CONSUME_KEY_PREFIX, userId);
    if (localStorage.getItem(key) !== ARMED_VALUE) return false;
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
